import styled, { css } from 'styled-components';

export const Wrapper = styled.aside`
  ${({ theme }) => css`
    background: ${theme.color.white};
    border: 1px solid ${({ theme }) => theme.color.background};
    border-top-left-radius: 0.4rem;
    border-top-right-radius: 0.4rem;

    @media (max-width: 768px) {
      margin: 0 auto;
      width: 100%;
    }
  `}
`;

export const Empty = styled.p`
  padding: 1rem;
  text-align: center;
`;
